export const SCREEN_READER_ONLY_CLASSNAME = "sr-only";
export const ALL_COLUMNS_CHECKBOX_ID = "all";
